// Ordered colors used for avatars and collaborations events
export const listColors = [
  '#734DBF',
  '#DB304D',
  '#4FBDB4',
  '#F0C330',
  '#DE64A3',
  '#766DD6',
  '#F76060',
  '#7BD8C1',
  '#FFD957',
  '#F073BC',
  '#9B93F7',
  '#FF7373',
  '#92EED8',
  '#FFDC68',
  '#FF91D2',
];

export const defaultColor = listColors[0];
